export default __webpack_public_path__ + "static/media/l.335e121b.jpg";